module.exports = __webpack_public_path__ + "img/ico-arrow-clock.6302ae41.svg";